import useMedia from "utils/hooks/useMedia";
import { CREATE_SIGNAL_PATH, MOBILE_CREATE_TRADE } from "common/constants";
import React, { useContext, useEffect } from "react";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import TradingTerminalProvider from "@shared/features/tradingTerminal/TradingTerminalProvider";
import WebTradingTerminalProvider from "features/tradingTerminal/WebTradingTerminalProvider";
import { useRouteMatch } from "react-router-dom";

const TradingTerminalWrapper = () => {
  const { analytics } = useContext(AnalyticsContext);
  const isMobile = useMedia(
    [`(max-width: ${MOBILE_CREATE_TRADE})`],
    [true],
    false
  );
  const isSignal = !!useRouteMatch(CREATE_SIGNAL_PATH);

  useEffect(() => {
    analytics?.tradingTerminalView({});
  }, [analytics]);

  return (
    <TradingTerminalProvider isMobile={isMobile} isSignal={isSignal}>
      <WebTradingTerminalProvider />
    </TradingTerminalProvider>
  );
};

export default TradingTerminalWrapper;
